import { motion } from "framer-motion";
import { processSteps } from "@/config/site";

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative py-28 md:py-36 overflow-hidden"
    >
      <div className="vs-container relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl"
        >
          <div className="flex items-center gap-3">
            <span className="h-px w-10 bg-[#d4af37]" />
            <span className="text-overline">Our Process</span>
          </div>
          <h2 className="mt-5 font-serif-display text-4xl md:text-6xl text-white tracking-tight leading-[1.02]">
            Six steps from
            <br />
            statements to <span className="italic vs-gold-text">strategy.</span>
          </h2>
        </motion.div>

        <div className="mt-20 relative">
          {/* tracing beam */}
          <div
            aria-hidden
            className="hidden md:block absolute left-1/2 top-0 bottom-0 w-px -translate-x-1/2"
            style={{
              background:
                "linear-gradient(180deg, transparent, rgba(212,175,55,0.5) 15%, rgba(212,175,55,0.5) 85%, transparent)",
            }}
          />
          <div className="md:hidden absolute left-6 top-0 bottom-0 w-px bg-[#d4af37]/40" />

          <ol className="space-y-14 md:space-y-24">
            {processSteps.map((step, idx) => {
              const isLeft = idx % 2 === 0;
              return (
                <motion.li
                  key={step.n}
                  data-testid={`process-step-${idx + 1}`}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.8 }}
                  className="relative grid md:grid-cols-2 gap-6 md:gap-16 items-center"
                >
                  {/* connector dot */}
                  <span
                    aria-hidden
                    className="hidden md:block absolute left-1/2 -translate-x-1/2 h-3 w-3 rounded-full bg-[#0d1220] border-2 border-[#d4af37]"
                  />
                  <span className="md:hidden absolute left-6 -translate-x-1/2 h-2.5 w-2.5 rounded-full bg-[#d4af37]" />

                  <div className={`${isLeft ? "md:pr-16 md:text-right" : "md:order-2 md:pl-16"} pl-12 md:pl-0`}>
                    <div className="font-mono-accent text-xs tracking-[0.3em] text-[#d4af37]">
                      STEP {step.n}
                    </div>
                    <h3 className="mt-3 font-serif-display text-3xl md:text-4xl text-white leading-tight tracking-tight">
                      {step.title}
                    </h3>
                  </div>

                  <div className={`${isLeft ? "" : "md:order-1 md:pr-16 md:text-right"} pl-12 md:pl-0`}>
                    <p className="text-white/65 font-body leading-relaxed max-w-md md:inline-block">
                      {step.desc}
                    </p>
                  </div>
                </motion.li>
              );
            })}
          </ol>
        </div>
      </div>
    </section>
  );
}
